export const VALID_ROUTES = [
  'account-plan/list',
  'account-structure/list',
  'accounting-closure/list',
  'accounting-concepts/list',
  'accounting-currency/list',
  'accounting-format/list',
  'accounting-parameters/list',
  'accrual-annulment/list',
  'accrual-approval/list',
  'accrual/list',
  'admin/dashboard',
  'admin/module-permissions',
  'admin/permissions',
  'admin/servers',
  'admin/tenants',
  'admin/users',
  'audit',
  'bank-account/list',
  'bank-closure/list',
  'bank-payment/list',
  'bank-reconciliation-config/list',
  'bank-reconciliation/list',
  'bank-transfer-annulment/list',
  'bank-transfer/list',
  'billing-concept/list',
  'billing-parameters/list',
  'budget-parameters/list',
  'ciudades/list',
  'cloud',
  'concept-entry-type/list',
  'consecutivo-def/list',
  'consecutivo-tipo/list',
  'credit-debit-note/list',
  'currency',
  'dashboard',
  'deferred-process/list',
  'deferred/list',
  'dependency/list',
  'departamentos/list',
  'department-city/list',
  'depreciation/list',
  'dian-concept/list',
  'electronic-payment-config/list',
  'electronic-payment-gen/list',
  'embargo/list',
  'estructura-historico/list',
  'exchange-rate/list',
  'expense-voucher/list',
  'funding-source/list',
  'income-annulment/list',
  'income-voucher/list',
  'ingest',
  'invoice-elaboration/list',
  'invoicing/list',
  'journal-entry-annulment/list',
  'journal-entry-deferred/list',
  'journal-entry-type/list',
  'journal-entry/list',
  'legal-hold',
  'masters/cost-center-type/list',
  'masters/cost-center/list',
  'masters/masters',
  'notifications',
  'other-deductions/list',
  'other-discount/list',
  'paises/list',
  'payment-annulment/list',
  'payment-confirmation/list',
  'payment-order-reception/list',
  'plan-cuentas-historico/list',
  'preservation-messages',
  'preservation',
  'reports',
  'repository-admin',
  'resource-type/list',
  'retention',
  'roles/list',
  'settings',
  'third-party/list',
  'tipo-plan-historico/list',
  'tipo-plan/list',
  'treasury-parameters/list',
  'treasury-third-party/list',
  'usuarios/list',
  'vault',
  'payment-file-scructure/list',
  'payment-files/list',
  'processing-of-bank/list',
  'parameters/list',
  'concepts-revenue/list',
  'processing-of-bank-cancellation/list',
  'invoice/list',
] as const;

export type ValidRoute = (typeof VALID_ROUTES)[number];

export function isRouteValid(route: string): boolean {
  if (!route) return false;

  const cleanRoute = route.split('?')[0].split('#')[0].toLowerCase().trim();

  const routeWithoutLayout = cleanRoute.replace(/^\/layout\//, '');

  const isValid = VALID_ROUTES.some(
    (valid) =>
      cleanRoute === valid.toLowerCase() ||
      cleanRoute.endsWith('/' + valid.toLowerCase()) ||
      routeWithoutLayout === valid.toLowerCase(),
  );

  return isValid;
}

export function getModuleFromRoute(
  route: string,
):
  | 'accounting'
  | 'tesorería'
  | 'budget'
  | 'vault'
  | 'maestros'
  | 'products'
  | 'company'
  | 'invoicing'
  | null {
  const lower = route.toLowerCase();

  if (
    lower.includes('/invoicing/') ||
    lower.includes('/invoicing') ||
    lower.includes('invoicing')
  ) {
    return 'invoicing';
  }

  if (lower.includes('/maestros/') || lower.includes('/maestros')) return 'maestros';
  if (lower.includes('/budget/') || lower.includes('budget-')) return 'budget';
  if (
    lower.includes('/tesorería/') ||
    lower.includes('/tesoreria/') ||
    lower.includes('treasury') ||
    lower.includes('banco') ||
    lower.includes('embargo')
  )
    return 'tesorería';
  if (lower.includes('/accounting/') || lower.includes('accounting')) return 'accounting';
  if (lower.includes('/products/') || lower.includes('products')) return 'products';
  if (lower.includes('/company/') || lower.includes('company')) return 'company';
  if (lower.includes('/vault/') || lower.includes('vault')) return 'vault';

  return null;
}
